import axios from 'axios'

export default {
  submit (order) {
    return axios
      .create()
      .post('/api/order', order)
      .then(res => res.data)
  }
}
